module.exports = __webpack_public_path__ + "img/boy.adb4bda3.png";